export default function (lst) {
    return (slug) => {
        const result = lst.find(item => {
            return slug === item.fields.slug.replace(/\//g, "")
        })
        return result
    }

}